import { ProductType } from '@/data/types/Product';
import { DEFAULT_STORE_ID } from 'shared/custom/constants/commonConstants';

import { useIsProductStoreOnlyAvailable } from '@/data/Content/useIsProductStoreOnlyAvailable';
import { usePhysicalStoreData } from '@/data/Content/usePhysicalStoreData';
import { useCurrentPhysicalStoreId } from '@/utils/useCurrentPhysicalStoreId';

export const useIsStoreOnlyAvailable = ({ product }: { product: ProductType }) => {
	const { physicalStoreId } = useCurrentPhysicalStoreId();
	const { marketId } = usePhysicalStoreData({
		physicalStoreId: physicalStoreId ?? DEFAULT_STORE_ID,
	});

	return useIsProductStoreOnlyAvailable({
		product,
		marketId,
	});
};
